import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i1678417239__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M9.288 7.778A4 4 0 1 0 2 5.5a3.95 3.95 0 0 0 .711 2.278c.116.166.254.353.4.553.404.553.885 1.216 1.244 1.869.325.594.49 1.213.572 1.797L3.406 12a3.6 3.6 0 0 0-.369-1.078c-.309-.563-.693-1.09-1.078-1.619-.162-.222-.325-.444-.48-.669a5.5 5.5 0 1 1 9.04 0q-.236.336-.481.67c-.385.524-.77 1.052-1.079 1.618-.184.337-.3.703-.368 1.078H7.07a5.2 5.2 0 0 1 .573-1.797c.36-.653.84-1.315 1.243-1.869.147-.2.282-.387.397-.553zM6 4a1.5 1.5 0 0 0-1.5 1.5c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5A2.5 2.5 0 0 1 6 3c.275 0 .5.225.5.5S6.275 4 6 4m0 12a2.5 2.5 0 0 1-2.5-2.5V13h5v.5A2.5 2.5 0 0 1 6 16"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1678417239__a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h12v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }